export const LIKEDONHOME = "LIKEDONHOME";
export const DISLIKEONHOME = "DISLIKEONHOME";
export const PENDINGONHOME = "PENDINGONHOME";

export const DOTRANSITION = "DOTRANSITION";
export const TRANSITIONCOMPLETE = "TRANSITIONCOMPLETE";


export const UPDATESTATUSEPIC = "UPDATESTATUSEPIC";
export const TOGGLESTATUSEPIC = "TOGGLESTATUSEPIC";
export const UPDATESTATUS = "UPDATESTATUS";

export const SORTREQUESTEPIC = "SORTREQUESTEPIC";
export const SORTREQUEST = "SORTREQUEST";

export const REQUESTHOMEIMGEPIC = "REQUESTHOMEIMGEPIC";
export const REQUESTHOMEIMG = "REQUESTHOMEIMG";

export const SEENITALL = "SEENITALL";

// export const MANAGERREADY = "MANAGERREADY";